import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Input, Button } from '../index'
import * as styles from './styles'

const propTypes = {
  data: PropTypes.object.isRequired
}

const EmailSignup = ({ data }) => (
  <styles.Container>
    <styles.TextWrapper>
      <styles.Header>{data.header}</styles.Header>
      <styles.Form action="https://aito.us18.list-manage.com/subscribe/post">
        <input type="hidden" name="u" value="e7ff1392b78623cfdcbda17c8" />
        <input type="hidden" name="id" value="305bbc6e91" />
        <Input placeholder={data.placeholder} name="EMAIL" required />
        {/*
        Autogenerated by mailchimp:
        "Real people should not fill this in and expect good things - do not remove this
        or risk form bot signups"
        */}
        <div style={{ position: 'absolute', left: '-5000px', ariaHidden: 'true' }}>
          <input type="text" name="b_e7ff1392b78623cfdcbda17c8_305bbc6e91" tabIndex="-1" />
        </div>

        <styles.ButtonContainer>
          <Button size="small">
            {data.button}
          </Button>
        </styles.ButtonContainer>
      </styles.Form>
      <styles.CenterTextWrapper>
        {data.disclaimer}
        {' '}
        <a target="_blank" rel="noopener noreferrer" href="/privacy">{data.disclaimerLink}</a>
        {' & '}
        <a target="_blank" rel="noopener noreferrer" href="/terms-of-service">terms of service</a>
        .
      </styles.CenterTextWrapper>
    </styles.TextWrapper>
  </styles.Container>
)

EmailSignup.propTypes = propTypes

export default () => (
  <StaticQuery
    query={graphql`
      query GetEmailSignup {
        allYaml(filter: {file: {eq: "email-signup"}}) {
          edges {
            node {
              header
              placeholder
              button
              disclaimer
              disclaimerLink
            }
          }
        }
      }
    `
    }
    render={(data) => {
      const { allYaml } = data
      const { edges } = allYaml
      const { node } = _.first(edges)
      return (
        <EmailSignup data={node} />
      )
    }}
  />
)
